import { render, staticRenderFns } from "./jobCanAppointment.vue?vue&type=template&id=b2f59bf0&scoped=true"
import script from "./jobCanAppointment.vue?vue&type=script&lang=js"
export * from "./jobCanAppointment.vue?vue&type=script&lang=js"
import style0 from "./jobCanAppointment.vue?vue&type=style&index=0&id=b2f59bf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f59bf0",
  null
  
)

export default component.exports